import { jsx } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { cx } from "@/lib/cx";
export function RuiSpinner({
  size = "md",
  aria,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    role: "status",
    aria: withDefaultAriaLabel(aria, "Loading"),
    class: cx("rui-spinner", `rui-spinner--${size}`, className)
  });
}